












import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import UserCard from '@/components/UserCard.vue';

import { UserProfileUtil } from '@/model-utils/user-profile-util';
import { UserProfile } from '@/models/user-profile';
import { UserModule } from '../store/modules/user';
import { UserFollowActions } from '../actions/user-follow-actions';

@Component({
  components: {
    UserCard
  }
})
export default class FollowersView extends Vue {
  @Prop(String) username: string;
  userProfile: UserProfile = null;
  users: UserProfile[] = [];

  async setUserProfile(userProfile: UserProfile) {
    
    this.userProfile = userProfile
    this.users = await UserFollowActions.getFollowersForUser(this.userProfile.id)
    
  }

  created() {
    UserProfileUtil.fetchProfileByUsername(this.username).then(this.setUserProfile);
  }
}
